import { BonusRoundQuestion } from "../model";

export const numberOfBonusRoundQuestions = (
  question: BonusRoundQuestion
): number => question.options.length;
